<template>
    <v-card style="height: 100%; max-height: 100%; overflow-y: auto" class="ma-0 pa-0" flat>
      <v-row class="ma-0 pa-0" style="width: 100%;" align="center">
          <v-col cols="12" v-if="!graph_visible">
            <v-skeleton-loader
                      light
                      :style="{
                        height: screenHeight + 'px',
                      }"
                      type="image,image,image,image"
            ></v-skeleton-loader>
          </v-col>
          <v-col v-if="graph_visible" class="ma-0 pa-0">
            <v-row class="ma-0 pa-0" style="height: 100%;">
                <v-col cols="12">
                  <div :style="{height: screenHeight + 'px'}"
                    >   
                      <v-chart
                        class="chartComponent"
                        :option="graph_options"
                        :ref="chart_ref"
                        :id="chart_id"
                        autoresize
                      ></v-chart>
                  </div>
                </v-col>
              <!-- </v-col> -->
            </v-row>
          </v-col>
      </v-row>
    </v-card>
</template>
  
<script>  
import VChart, { THEME_KEY } from 'vue-echarts';
import "echarts";
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers'; 'echarts/charts';
import {
    TitleComponent,
    TooltipComponent,
    LegendComponent,
} from 'echarts/components';

use([
    CanvasRenderer,
    TitleComponent,
    TooltipComponent,
    LegendComponent,
]);


export default {
name: "PurchaseCycleChart",
props: [
    'dataset',
    'chart_ref',
    'chart_id',
],
components: {
    VChart
},
provide: {
    [THEME_KEY]: 'light',
},
methods: {
    reload_graph: function () {
    this.graph_visible = false;
    setTimeout(() => (this.graph_visible = true), 10);
    }
},

data: () => ({
    graph_visible: false,
    graph_data: null,
    screenHeight: window.innerHeight * 0.6,
}),
mounted() {
    this.graph_data = this.dataset;
    if(this.dataset != null){
    this.reload_graph();
    }
},
watch: {
    dataset: {
    immediate: true,
    handler: function () {
        this.graph_data = this.dataset;
        if(this.dataset != null){
        this.reload_graph();
        }
    },
    deep: true,
    }
},
computed: {
    graph_options: function() {
      let dataset = JSON.parse(JSON.stringify(this.graph_data));
      let data_category = [];
      let data_series = [];
      let data = [];
      let series = [];
      if (dataset != null) {
        data = Array.from(Array(dataset[0].length - 1), () => []);
        data_series = dataset[0];
        data_series.shift();

        for (let i = 1; i < dataset.length; i++) {
          data_category.push(dataset[i][0]);

          for (let j = 1; j < dataset[i].length; j++) {
            data[j - 1].push(dataset[i][j]);
          }
        }

        for (let idx = 0; idx < data.length; idx++) {
          series.push({
            name: data_series[idx],
            showSymbol: false,
            type: data_series[idx] == 'Conversion Rate' ? "line" : "bar",
            stack: data_series[idx] == 'Conversion Rate' ? "none" : "total",
            barWidth: '100%',
            data: data[idx],
            emphasis: {
              focus: "series",
            },
            yAxisIndex: data_series[idx] == 'Conversion Rate' ? 1 : 0,
          });
        }
      }

      const option = {
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: data_series,
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: data_category,
            axisTick: {
              alignWithLabel: true,
            },
            axisLabel: {
              fontSize: 14,
              fontFamily: "Poppins"
            }
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              fontSize: 14,
              fontFamily: "Poppins"
            }
          },
          {
            name: 'Conversion Rate',
            type: 'value',
            alignTicks: true,
            axisLabel: {
              fontSize: 14,
              fontFamily: "Poppins",
              formatter: function(d) {
                return (d * 100).toLocaleString("en-CA",{minimumFractionDigits: 0, maximumFractionDigits: 0, notation: 'compact'}) + "%"
              }
            }
          }
        ],
        series: series,
      };
      return option;
    }
}
};
</script>

<style scoped>

.chartComponent {
  height: 100%;
  width: 100%;
}

</style>
  